import React from 'react';
import BottomTabNav from '../shared/components/BottomTabNav';
import Footer from '../shared/components/Footer';
import './CustomerAboutUs.css';

const CustomerAboutUs = () => {
  return (
    <div className="App">
      <div className="about-container">
        <div className="about-content">
          {/* Header */}
          <div className="about-header">
            <h1 className="about-title">About ZepEat</h1>
            <p className="about-subtitle">Your trusted food and grocery delivery partner</p>
          </div>

          {/* App Info Section */}
          <div className="about-section">
            <h2 className="section-title">About Our App</h2>
            <div className="info-card">
              <div className="info-item">
                <div className="info-icon">🍽️</div>
                <div className="info-content">
                  <h3>Food Delivery</h3>
                  <p>Order from your favorite restaurants with fast and reliable delivery service.</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon">🛒</div>
                <div className="info-content">
                  <h3>Grocery Shopping</h3>
                  <p>Get fresh groceries and daily essentials delivered to your doorstep.</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon">⚡</div>
                <div className="info-content">
                  <h3>Fast Delivery</h3>
                  <p>Quick delivery within 30-60 minutes for your convenience.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Rules & Regulations */}
          <div className="about-section">
            <h2 className="section-title">Rules & Regulations</h2>
            <div className="rules-card">
              <div className="rule-item">
                <h3>Order Policy</h3>
                <ul>
                  <li>Minimum order value: $10 for food, $15 for grocery</li>
                  <li>Orders can be cancelled within 5 minutes of placement</li>
                  <li>Delivery time: 30-60 minutes depending on distance</li>
                  <li>Free delivery on orders above $150</li>
                </ul>
              </div>
              <div className="rule-item">
                <h3>Payment Terms</h3>
                <ul>
                  <li>We accept cash, credit/debit cards, and digital wallets</li>
                  <li>Payment is due upon delivery</li>
                  <li>Refunds processed within 3-5 business days</li>
                  <li>No additional charges for payment processing</li>
                </ul>
              </div>
              <div className="rule-item">
                <h3>Quality Assurance</h3>
                <ul>
                  <li>Fresh ingredients guaranteed for all orders</li>
                  <li>Temperature-controlled delivery for food items</li>
                  <li>Quality check before dispatch</li>
                  <li>100% satisfaction guarantee</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="about-section">
            <h2 className="section-title">Contact Us</h2>
            <div className="contact-card">
              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div className="contact-info">
                  <h3>Phone Support</h3>
                  <p>+1 (555) 123-4567</p>
                  <span>Available 24/7</span>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div className="contact-info">
                  <h3>Email Support</h3>
                  <p>support@zepeat.com</p>
                  <span>Response within 2 hours</span>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div className="contact-info">
                  <h3>Office Address</h3>
                  <p>123 Food Street, City Center</p>
                  <span>Business Hours: 9 AM - 9 PM</span>
                </div>
              </div>
            </div>
          </div>

          {/* App Features */}
          <div className="about-section">
            <h2 className="section-title">App Features</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">🔍</div>
                <h3>Smart Search</h3>
                <p>Find your favorite food and grocery items quickly</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">⭐</div>
                <h3>Reviews & Ratings</h3>
                <p>Read reviews and ratings from other customers</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">💳</div>
                <h3>Secure Payments</h3>
                <p>Safe and secure payment processing</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">📱</div>
                <h3>Real-time Tracking</h3>
                <p>Track your order in real-time</p>
              </div>
            </div>
          </div>

          {/* Terms & Privacy */}
          <div className="about-section">
            <h2 className="section-title">Legal Information</h2>
            <div className="legal-card">
              <div className="legal-item">
                <h3>Terms of Service</h3>
                <p>By using our app, you agree to our terms and conditions. Please read our complete terms of service for detailed information.</p>
              </div>
              <div className="legal-item">
                <h3>Privacy Policy</h3>
                <p>We respect your privacy and protect your personal information. Our privacy policy explains how we collect and use your data.</p>
              </div>
              <div className="legal-item">
                <h3>Data Protection</h3>
                <p>Your data is encrypted and stored securely. We never share your personal information with third parties without consent.</p>
              </div>
            </div>
          </div>

        </div>
      </div>
      
      <Footer websiteType="customer" />
      <BottomTabNav />
    </div>
  );
};

export default CustomerAboutUs;
